import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { store } from "../../../utils/httpUtil";

export const searchHrCompileDetailsWithCriteria = createAsyncThunk(
  "hr/search/compile",
  async (payload) => {
    try {
      const response = await store("v1/hr/compile", payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

const listPending = ["hr/search/compile/pending"];
const listFulfilled = ["hr/search/compile/fulfilled"];
const listRejected = ["hr/search/compile/rejected"];

export const hrCompileSlice = createSlice({
  name: "hrCompile",
  initialState: {
    payload: [],
    loading: false,
    errors: {},
  },
  reducers: {
    cleanHrCompileDetail(state) {
      state.payload = [];
      state.loading = false;
      state.errors = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action) => listPending.includes(action.type),
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        (action) => listFulfilled.includes(action.type),
        (state, action) => {
          state.loading = false;
          state.payload = action.payload?.data;
        }
      )
      .addMatcher(
        (action) => listRejected.includes(action.type),
        (state, action) => {
          state.loading = false;
          state.errors = action.error;
        }
      );
  },
});

export const { cleanHrCompileDetail } = hrCompileSlice.actions;
export default hrCompileSlice;
